export const headerMenus = [
  {
    title: '图片压缩',
    key: 'compress',
    category: 'imageCompress',
    children: [
      {
        title: '图片压缩',
        link: '/',
        icon: require('@/assets/img/compress_pic_icon.svg')
      },
      {
        title: 'JPG压缩',
        link: '/compress/jpg',
        icon: require('@/assets/img/compress_jpg_icon.svg')
      },
      // {
      //   title: 'GIF压缩',
      //   link: '/compress/gif',
      //   icon: require('@/assets/img/compress_gif_icon.svg')
      // },
      {
        title: 'PNG压缩',
        link: '/compress/png',
        icon: require('@/assets/img/compress_png_icon.svg')
      },
      {
        title: 'BMP压缩',
        link: '/compress/bmp',
        icon: require('@/assets/img/compress_bmp.svg')
      },
      {
        title: 'WEBP压缩',
        link: '/compress/webp',
        icon: require('@/assets/img/compress_webp_icon.svg')
      },
      {
        title: '证件照压缩',
        link: '/compress/zjz',
        icon: require('@/assets/img/compress_zjz_icon.svg')
      },
      {
        title: '压缩指定大小',
        link: '/compress/size',
        icon: require('@/assets/img/compress_size_icon.svg')
      }
    ]
  },
  {
    title: '图片编辑',
    key: 'edit',
    category: 'imageEdit',
    children: [
      {
        title: '图片改尺寸',
        link: '/edit',
        icon: require('@/assets/img/edit_pic_icon.svg')
      },
      {
        title: '修改DPI',
        link: '/edit/dpi',
        icon: require('@/assets/img/dpi_icon.svg')
      },
      {
        title: '内存变大',
        link: '/edit/increase-memory',
        icon: require('@/assets/img/compress_size_icon.svg')
      }
    ]
  },
  {
    title: '图片格式转换',
    key: 'convert',
    category: 'imageConvert',
    children: [
      {
        title: '图片格式转换',
        link: '/convert',
        icon: require('@/assets/img/pic_format_icon.svg')
      },
      {
        title: 'HEIC转JPG',
        link: '/convert/heic2jpg',
        icon: require('@/assets/img/heic2jpg.svg')
      },
      {
        title: 'TIFF转JPG',
        link: '/convert/tiff2jpg',
        icon: require('@/assets/img/tiff2jpg.svg')
      },
      {
        title: '图片转ICO',
        link: '/convert/2ico',
        icon: require('@/assets/img/pic2ico.svg')
      },
      {
        title: '图片转JPG',
        link: '/convert/2jpg',
        icon: require('@/assets/img/pic2jpg.svg')
      },
      {
        title: '图片转PNG',
        link: '/convert/2png',
        icon: require('@/assets/img/pic2png.svg')
      },
      {
        title: '图片转BMP',
        link: '/convert/2bmp',
        icon: require('@/assets/img/pic2bmp.svg')
      },
      {
        title: '图片转WEBP',
        link: '/convert/2webp',
        icon: require('@/assets/img/pic2webp.svg')
      }
    ]
  },
  {
    title: 'PDF转换',
    key: 'pdf',
    category: 'pdfConvert',
    children: [
      {
        title: 'PDF压缩',
        link: '/pdf/compress',
        icon: require('@/assets/img/pdf/pdf_compress_icon.svg')
      },
      {
        title: 'PDF转Word',
        link: '/pdf/to-word',
        icon: require('@/assets/img/pdf/pdf2word_icon.svg')
      },
      {
        title: 'PDF转图片',
        link: '/pdf/to-img',
        icon: require('@/assets/img/pdf/pdf2img_icon.svg')
      },
      {
        title: 'PDF转PPT',
        link: '/pdf/to-ppt',
        icon: require('@/assets/img/pdf/pdf2ppt_icon.svg')
      },
      {
        title: 'PDF转Excel',
        link: '/pdf/to-excel',
        icon: require('@/assets/img/pdf/pdf2excel_icon.svg')
      },
      {
        title: 'Word转PDF',
        link: '/pdf/word2pdf',
        icon: require('@/assets/img/pdf/word2pdf_icon.svg')
      },
      {
        title: '图片转PDF',
        link: '/pdf/img2pdf',
        icon: require('@/assets/img/pdf/img2pdf_icon.svg')
      },
      {
        title: 'PPT转PDF',
        link: '/pdf/ppt2pdf',
        icon: require('@/assets/img/pdf/ppt2pdf_icon.svg')
      },
      {
        title: 'Excel转PDF',
        link: '/pdf/excel2pdf',
        icon: require('@/assets/img/pdf/excel2pdf_icon.svg')
      },
      {
        title: 'CAD转PDF',
        link: '/pdf/cad2pdf',
        icon: require('@/assets/img/pdf/cad2pdf_icon.svg')
      }
    ]
  }
]
